// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  url: {
    PLAY_URL: 'https://forecast.vassarlabs.com/api/aw/',
    OBSERVED_API_URL: 'https://metWISE.vassarlabs.com/wrimsApi/api/',//'http://192.168.14.175:8080/api/',
    APWRIMS_STAGING_API_URL : 'https://metWISE.vassarlabs.com/apwrims/api/',
    HEATWAVE_STAGING_API_URL : 'https://metWISE.vassarlabs.com/hwApi/api/',//'http://192.168.14.175:8080/api/',
    KALESHWARAM_API_URL: 'http://kaleshwaram.vassarlabs.com/api/',
    KALESHWARAM_WRIS_API_URL: 'http://kaleshwaram-wris.vassarlabs.com/api/',
    temp2 : 'https://metWISE.vassarlabs.com/hwApi/api/',
    AP_GEOSERVER_URL : 'http://heatwave-staging.vassarlabs.com/geoserver/',
    TNOD_GEOSERVER_URL : 'http://20.219.166.170:8080/geoserver/',
    // NEW_GEOSERVER_URL : 'http://20.219.166.170/geoserver/',
    NEW_GEOSERVER_URL : 'http://acerkrishidss.vassarlabs.com/new-geoserver/',
    KLWSGEOSERVER_URL : 'http://159.65.4.230/geoserver/kaleshwaram/',
    // GEOSERVER_URL:"http://heatwave-staging.vassarlabs.com/",
    GEOSERVER_URL:"http://acerkrishidss.vassarlabs.com/",
    USERMANAGEMENT_URL:'http://heatwave-staging.vassarlabs.com/',
    COMMON_GEOSERVER_URL:'https://metwise-geoserver.vassarlabs.com/new-geoserver/',
    COMMON_GEO_URL:'http://localhost:8080/geoserver/',
    METWISE_ANALYTICS_API:'https://metWISE.vassarlabs.com/analyticsApi/getUserDetails'
    // PLAY_URL:"http://localhost:9000/api/aw/"
  },
  urlMapping: {
    PROJ_API: 'https://forecast.vassarlabs.com/api/aw/'
    // PROJ_API: 'http://f9675ebab936.ngrok.io/api/aw/'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
